export default "__VITE_ASSET__CtbWKKro__"